import axios from "axios";

export const apiUpdateReferralName = async (linkId, newName) => {
    const token = localStorage.getItem('token');
    const response = await axios.patch(
      `${process.env.REACT_APP_SERVER_API}/referrals/links/${linkId}/update-name/`,
      { readable_name: newName },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      }
    );
    return response.data;
  };